import {
    FiltersType,
    GenresType,
    PaginationType,
} from '../worldOfMovies/WOM.interface';
import { ReduxAction } from './interface';

const actionsType = {
    toggleDrawerMenu: 'TOGGLE_DRAWER_MENU',
    getAllGenres: 'GET_ALL_GENRES',
    getFilters: 'GET_FILTERS',
    getPagination: 'GET_PAGINATION',
};

const toggleDrawerMenu = (): ReduxAction => ({
    type: actionsType.toggleDrawerMenu,
});

const getAllGenres = (payload: GenresType[] | undefined): ReduxAction => ({
    type: actionsType.getAllGenres,
    payload,
});

const getFilters = (payload: FiltersType): ReduxAction => ({
    type: actionsType.getFilters,
    payload,
});

const getPagination = (payload: PaginationType): ReduxAction => ({
    type: actionsType.getPagination,
    payload,
});

export {
    actionsType,
    toggleDrawerMenu,
    getAllGenres,
    getFilters,
    getPagination,
};
